import actionCreatorFactory from "typescript-fsa";

import { normalizeActions } from "@ea/shared_components/redux/common.actions";
import {
  createDataModuleActions,
  createTableActionsGetter,
} from "@ea/shared_components/redux/common.data.actions";
import { UserGroup } from "@ea/shared_types/types";

const actionCreator = actionCreatorFactory("USER_GROUP_MODULE");

export const moduleActions = createDataModuleActions<UserGroup>(actionCreator);
export const getUserGroupTableActions = createTableActionsGetter(
  normalizeActions(moduleActions.table),
);
export const userGroupActions = {
  ...normalizeActions(moduleActions.data),
};
export const userGroupActionCreators = {
  ...moduleActions,
};
